export default {
  app: {
    golf: {
      title: 'Информация о поле',
      hasEVChargingPoint: 'Пункт зарядки электромобилей',
      hasCaddieService: 'Услуги кэдди',
      hasTrolley: 'Тележка',
      hasBuggy: 'Багги',
      hasClubRental: 'Прокат клюшек',
      hasAcademy: 'Академия',
      hasMarshal: 'Маршал',
      hasPGACertification: 'Сертификация PGA',
      hasTrainingArea: 'Тренировочная зона',
      hasRestaurant: 'Ресторан',
      hasHotel: 'Отель',
      hasDogsOnCourse: 'Собаки на поле',
      numberOfHoles: 'Количество лунок',
    },
  },
};
